import { Card, Row, Space } from 'antd';
import styled from 'styled-components';

export const TitleRow = styled(Row)`
  margin-bottom: 1.5rem;
`;

export const FullWidthSpace = styled(Space)`
  width: 100%;
`;

export const RoundedCard = styled(Card)`
  border-radius: 0.5rem;
  height: 100%;
`;
